import { useState, useEffect } from 'react';

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [retryCount, setRetryCount] = useState(0);
  const maxRetries = 3;

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setRetryCount(0); // Reset retry count when we're back online
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check connection status periodically when offline
    let intervalId: NodeJS.Timeout | null = null;
    if (!isOnline && retryCount < maxRetries) {
      intervalId = setInterval(() => {
        fetch('/ping')
          .then(() => {
            setIsOnline(true);
            setRetryCount(0);
          })
          .catch(() => {
            setRetryCount((prev) => prev + 1);
          });
      }, 5000); // Check every 5 seconds
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isOnline, retryCount]);

  return {
    isOnline,
    retryCount,
    maxRetries,
    hasExhaustedRetries: retryCount >= maxRetries
  };
}; 